export default __webpack_public_path__ + "static/media/10.757cdbb2.jpg";